<script></script>

<div class="explanation">
    <p>
        “Pleasure to me is wonder—the unexplored, the unexpected, the thing that
        is hidden and the changeless thing that lurks behind superficial
        mutability.”
    </p>
    <p>- H.P. Lovecraft</p>
</div>

<style>
    div.explanation p {
        font-family: "IM Fell English SC", serif;
        font-size: 14pt;
        text-align: left;
        padding: 5px;
        margin-right: 10px;
        text-shadow: 3px 3px 8px #000;
    }
</style>
